import { Event } from "./Event";
export class ItemMovedEvent extends Event {
    /**
     * Constructor
     * @param element element
     * @param data data
     * @param fromIndex from index
     * @param toIndex to index
     */
    constructor(element, data, fromIndex, toIndex) {
        super(element, data);
        this.fromIndex = fromIndex;
        this.toIndex = toIndex;
    }
    /**
     * Gets from index
     */
    getFromIndex() {
        return this.fromIndex;
    }
    /**
     * Gets to index
     */
    getToIndex() {
        return this.toIndex;
    }
}
//# sourceMappingURL=ItemMovedEvent.js.map